import React from 'react';

const ContactForm = ({ formData, handleChange, setFormData }) => {
  // Function to Add a New Row
  const addRow = () => {
    const newRow = { contactName: "", contactPhone: "", contactEmail: "", contactAddress1: "", contactAddress2: "", contactAddress3: "", contactNotices: "", contactCorrespondence: "", contactTaxInfo: "", contactLegalDocs: "" };
    const rows = formData.rows || [];
    setFormData(prev => ({ ...prev, rows: [...rows, newRow] }));
  };

  return (
    <div className="contact-container">
      <h2 className="checklist-title">Contact Form</h2>

      <p className='center-text'>
        If you want certain documents sent to someone in addition to the notice information set forth above, fill out the below. Otherwise, you can skip to the next section.
      </p>

      <h4 className="checklist-title">Please Check All that Apply</h4>

      <>
        <table className="contact-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Contact Information</th>
              <th>Address</th>
              <th>Capital Call & Distribution Notices</th>
              <th>General Correspondence</th>
              <th>Tax and Financial Information</th>
              <th>Legal Documents</th>
            </tr>
          </thead>
          <tbody>
            {(formData.rows || []).map((row, index) => (
              <tr key={index}>
                <td className="wide-column">
                  <input
                    type="text"
                    className="table-input"
                    name={`rows.${index}.contactName`}
                    value={row.name}
                    onChange={(event) => handleChange(event, setFormData)}
                    placeholder="Enter Contact Name"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="table-input"
                    name={`rows.${index}.contactPhone`}
                    value={row.phone}
                    onChange={(event) => handleChange(event, setFormData)}
                    placeholder="Enter Telephone"
                  />
                  <input
                    type="email"
                    className="table-input"
                    name={`rows.${index}.contactEmail`}
                    value={row.email}
                    onChange={(event) => handleChange(event, setFormData)}
                    placeholder="Enter Email"
                  />
                </td>
                <td className="wide-column">
                  <input
                    type="text"
                    className="table-input"
                    name={`rows.${index}.contactAddress1`}
                    value={row.address1}
                    onChange={(event) => handleChange(event, setFormData)}
                    placeholder="Street Address/Suite"
                  />
                  <input
                    type="text"
                    className="table-input"
                    name={`rows.${index}.contactAddress2`}
                    value={row.address2}
                    onChange={(event) => handleChange(event, setFormData)}
                    placeholder="City, State, Zip"
                  />
                </td>
                <td>
                  <input 
                    type="checkbox" 
                    name={`rows.${index}.contactNotices`} 
                    checked={row.contactNotices === true} 
                    onChange={(event) => handleChange(event, setFormData)} 
                  />
                </td>
                <td>
                  <input 
                    type="checkbox" 
                    name={`rows.${index}.contactCorrespondence`} 
                    checked={row.contactCorrespondence === true} 
                    onChange={(event) => handleChange(event, setFormData)} 
                  />
                </td>
                <td>
                  <input 
                    type="checkbox" 
                    name={`rows.${index}.contactTaxInfo`} 
                    checked={row.contactTaxInfo === true} 
                    onChange={(event) => handleChange(event, setFormData)} 
                  />
                </td>
                <td>
                  <input 
                    type="checkbox" 
                    name={`rows.${index}.contactLegalDocs`} 
                    checked={row.contactLegalDocs === true} 
                    onChange={(event) => handleChange(event, setFormData)} 
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <button type="button" className="add-row-button" onClick={addRow}>+ Add Row</button>
      </>
    </div>
  );
};

export default ContactForm;
